import { useScopedNumericQuery } from '@/hooks/useScopedNumericQuery';
import { PERMISSIONS } from '@helios/authz';
import type { InvoiceDirection } from './financeInvoices.types';
import { financeInvoiceEvidenceApi } from './financeInvoiceEvidence.api';
import type { InvoiceActivitySource } from './financeInvoiceEvidence.types';

export const invoiceEvidenceRead = (direction: InvoiceDirection) =>
  direction === 'ar' ? PERMISSIONS.FINANCE_AR_INVOICES_READ : PERMISSIONS.FINANCE_AP_INVOICES_READ;

export function useFinanceInvoiceEvidence(direction: InvoiceDirection, id: string, page: number) {
  return useScopedNumericQuery(
    ['finance', 'invoice-evidence', direction, id, page],
    invoiceEvidenceRead(direction),
    (options) => financeInvoiceEvidenceApi.list(direction, id, page, options),
    { staleTime: 0 },
  );
}

export function useFinanceInvoiceActivityOptions(
  direction: InvoiceDirection,
  id: string,
  sourceType: InvoiceActivitySource,
  search: string,
  page: number,
) {
  return useScopedNumericQuery(
    ['finance', 'invoice-evidence-options', direction, id, sourceType, search, page],
    invoiceEvidenceRead(direction),
    (options) =>
      financeInvoiceEvidenceApi.options(direction, id, sourceType, search, page, options),
    { staleTime: 0 },
  );
}
